import free_email_provider_set from './free_email_provider_domains'

export const isCompanyEmail = (email) => {
  const fields = email.split('@')
  const domain = fields[1]
  return !free_email_provider_set.has(domain)
}
